import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { quillEditor } from 'vue-quill-editor';
import quillConfig from '@/views/components/editor/quill-config.js';
import { clipboardCopy } from '@/utils/clipboard';
import { systemConfigStore, systemConfigEdit, systemConfigFileList } from '../request';
export default {
  props: {
    type: {
      type: String,
      required: true,
      default: ''
    },
    language: {
      type: String,
      required: true,
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    quillEditor
  },
  data() {
    return {
      form: {
        fileContent: ''
      },
      quillOption: quillConfig,
      fileId: undefined,
      btnShow: 1,
      //1:保存 2:编辑 3:取消
      isEdit: true,
      //是否可编辑
      oldForm: {},
      fileList: [],
      disableBtn: false
    };
  },
  computed: {
    rules() {
      return {
        fileContent: [{
          required: true,
          validator: this.checkEditorCont,
          trigger: 'change'
        }]
      };
    }
  },
  mounted() {
    // 判断传过来的是否有值，有值赋值，没值使用form默认值
    if (this.item[this.language]) {
      this.form = this.item[this.language];
      this.btnShow = 2;
      this.isEdit = false;
      this.oldForm = JSON.parse(JSON.stringify(this.form));
      this.$nextTick(() => {
        this.disableEditor(false);
        console.log(this.isEdit, '--------mounted有值 false-----------');
      });
    } else {
      this.btnShow = 1;
      this.isEdit = true;
      this.$nextTick(() => {
        this.disableEditor(true);
        console.log(this.isEdit, '--------mounted没值 true-----------');
      });
    }
  },
  methods: {
    disableEditor(status) {
      console.log(status, '--------disableEditor status---------', !status);
      // 禁用所有工具栏按钮
      const toolbarButtons = document.querySelectorAll('.ql-toolbar button');
      console.log(toolbarButtons, 'toolbarButtons');
      toolbarButtons.forEach(button => {
        button.disabled = status ? false : true;
      });
    },
    // 校验富文本是否有真实内容
    checkEditorCont(rule, value, callback) {
      console.log(this.$refs.myTextEditor.quill.getText(), this.$refs.myTextEditor, 'this.$refs.myTextEditor.quill.getText()');
      const editorContent = this.$refs.myTextEditor.quill.root.innerHTML;
      // 使用DOMParser解析HTML字符串为DOM对象
      const parser = new DOMParser();
      const doc = parser.parseFromString(editorContent, 'text/html');
      // 获取解析后的文本内容
      const textContent = doc.body.textContent || '';
      console.log(textContent, 'textContent');
      const trimContent = textContent.trim();
      console.log(trimContent, 'trimContent', !trimContent, !editorContent.includes('<img'));
      if (!trimContent && !editorContent.includes('<img')) {
        callback(new Error(this.$t('请输入') + this.$t('文件内容')));
      } else {
        callback();
      }
    },
    filterTags(node) {
      // 过滤掉除了img标签之外的所有标签
      const walker = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT, {
        acceptNode: currentNode => {
          return currentNode.tagName.toLowerCase() === 'img' ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      }, false);
      let currentNode;
      let filteredContent = '';
      while (currentNode = walker.nextNode()) {
        filteredContent += currentNode.outerHTML;
      }
      return filteredContent;
    },
    // 获取文件列表
    async getSystemConfigFileList() {
      let res = await systemConfigFileList({
        language: this.language,
        page: 1,
        pageSize: 9999999
      });
      console.log(res);
      this.fileList = res.items;
    },
    // 文件选择
    fileChange(value) {
      this.fileId = value;
    },
    // 复制
    handleCopy(item, event) {
      let msg = item !== 'undefined' ? this.$t('复制成功') : this.$t('请选择') + this.$t('链接文件');
      let newLink = `${process.env.VUE_APP_BASE_URL}/system/settings/previewPage/${item}/${this.language}/2`;
      if (item === 'undefined') {
        newLink = '';
      }
      clipboardCopy(false, newLink, event, msg);
    },
    // 保存
    saveForm() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          var _this$form;
          this.disableBtn = true;
          let res;
          if ((_this$form = this.form) !== null && _this$form !== void 0 && _this$form.id) {
            // 编辑
            const params = Object.assign({}, this.form, {
              id: this.form.id,
              type: this.type,
              language: this.language
            });
            res = await systemConfigEdit(params);
          } else {
            const params = Object.assign({}, this.form, {
              type: this.type,
              language: this.language
            });
            res = await systemConfigStore(params);
            this.form.id = res;
          }
          if (res) {
            this.$message.success(this.$t('保存成功'));
            this.btnShow = 2;
            this.isEdit = false;
            this.disableEditor(this.isEdit);
            this.oldForm = JSON.parse(JSON.stringify(this.form));
            this.fileId = undefined;
            this.disableBtn = false;
          }
        }
      });
    },
    // 编辑
    editForm() {
      this.btnShow = 3;
      this.isEdit = true;
      this.disableEditor(this.isEdit);
    },
    // 取消-
    cancelForm() {
      this.btnShow = 2;
      this.isEdit = false;
      this.disableEditor(this.isEdit);
      // 数据重置
      this.form = JSON.parse(JSON.stringify(this.oldForm));
      this.fileId = undefined;
    }
  }
};